import Joi from 'joi';
import { ProductType } from 'constants.js';
import { constants } from 'views/Campaign';

const {
  campaignOccurrenceTypes: { ON_EVENT }
} = constants;

export default {
  campaignOccurrenceType: Joi.string()
    .required()
    .label('Automation'),
  productName: Joi.string()
    .label('Product Type')
    .required(),
  subscriberListId: Joi.when('campaignOccurrenceType', {
    is: 'ON_DEMAND' || 'INTERNAL_SURVEY_RESPONSE',
    then: Joi.when('productType', {
      is: ProductType.List,
      then: Joi.string()
        .label('Subscribers List')
        .required()
    })
  }),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required()
};
